import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useBranchContext } from "@/hooks/useBranchContext";
import { useOrganizationContext } from "@/hooks/useOrganizationContext";

export interface User {
  id: string;
  fullName: string;
  role: string | null;
  department: string | null;
}

export const useAllUsers = () => {
  const { currentBranchId } = useBranchContext();
  const { organizationId } = useOrganizationContext();
  return useQuery({
    queryKey: ["all-users", organizationId, currentBranchId],
    queryFn: async () => {
      if (currentBranchId == null || !organizationId) return [];
      const { data, error } = await supabase
        .from("profiles")
        .select("id, full_name, role, department, profile_branches!inner(branch_id)")
        .eq("status", "active")
        .eq("organization_id", organizationId)
        .eq("profile_branches.branch_id", currentBranchId)
        .order("full_name", { ascending: true });

      if (error) {
        console.error("Error fetching users:", error);
        throw error;
      }

      return (data || []).map((user) => ({
        id: user.id,
        fullName: user.full_name || "Unknown",
        role: user.role,
        department: user.department,
      }));
    },
    enabled: currentBranchId != null && !!organizationId,
  });
};
